import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

// -- Models -- //
import { User } from '@app/models/backend';

// -- Utils -- //
import { regex, regexErrors, markFormGroupTouched, DobValidator, repeatPasswordValidator } from '@app/shared';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import { EnumService, HelperService, NotificationService, UserService } from '@app/core/services';

@Component({
  selector: 'app-personal-detail',
  templateUrl: './personal-detail.component.html',
  styleUrls: ['./personal-detail.component.scss']
})
export class PersonalDetailComponent implements OnInit, OnChanges {

  personalForm!: FormGroup;
  approvalForm!: FormGroup;
  regexErrors = regexErrors;

  @Input() metaData: any;
  @Input() personalInfo!: User;
  @Input() isAdmin: boolean = false;
  @Input() departmentRolesMeta: any;
  @Input() dropdownList: any;
  @Input() userProfile!: User;
  @Input() roles: any;
  @Input() isProfileEditable!: boolean;
  @Input() isCreate!: boolean;
  @Input() isUserCreated!: boolean;
  @Input() rolesSelected: any[] = [];
  @Input() profile: any;
  @Input() isPersonalDetail: boolean = false;


  @Output() emitPersonalForm = new EventEmitter();
  @Output() emitcreateNewUserForm = new EventEmitter();
  @Output() emitPersonalDetail = new EventEmitter();

  items!: any;
  maxDate!: Date;
  provinceCities: any[] = [];

  profileDetail!: User;

  isSubmitted: boolean = false;
  isEditMode: boolean = false;

  isBDURegistration = false;
  isOtherRegistration = false;

  lookupSelfRegistration: number = 130;
  lookupOtherRegistration: number = 131;
  lookupBDURegistration: number = 132;

  isPartyUser: boolean = false;

  dropdownSettings: IDropdownSettings =
    {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    }

  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private notification: NotificationService,
    private router: Router,
    public helperService: HelperService,
    public userService: UserService,
    public enumService: EnumService) { }

  ngOnInit(): void {
    this.maxDate = new Date;
    this.provinceCities;
    this.initForm();
    this.route.paramMap.subscribe((res: any) => {
      const id = res['params'].id;

      this.personalForm.controls?.provinceId?.valueChanges.subscribe((res: any) => {
        this.selectProvince(this.userProfile?.provinceId);
      });

    });

    if (this.router.url === '/home/profile' || this.router.url.includes('/home/profile')) {
      this.isEditMode = true;
      this.personalForm.get('agree')?.clearValidators();
      this.personalForm.get('agree')?.updateValueAndValidity();
    }
    // if user that is being displayed is Admin User
    if (this.isAdmin) {

      if (!this.isProfileEditable) {
        this.personalForm.disable();
      }
    }

    // check if LoggedIn user is Party User 
    let currentUser = JSON.parse(localStorage.getItem('user')!);
    this.isPartyUser = currentUser.isPartyUser;

  }

  // -- ngOnChanges -- //
  ngOnChanges(simpleChanges: SimpleChanges) {

    if (simpleChanges.userProfile && this.userProfile) {

      // if (this.userProfile != undefined && this.userProfile.registrationTypeId <= 0) {
      //   this.userProfile.registrationTypeId = this.lookupSelfRegistration;
      // }
      // this.registrationTypeChange(this.userProfile?.registrationTypeId);


      this.personalForm.patchValue({
        ...this.userProfile,
        dob: new Date(this.userProfile.dob),
        lstRoles: this.roles
      });
      this.selectProvince(this.personalForm.value.provinceId);
      // if (this.profile && this.profile.user.approvalStatusId != 4) {
      //   this.approvalForm.controls['taggedUserId'].disable();
      //   this.approvalForm.controls['otherDetails'].disable();
      //   this.approvalForm.controls['registrationTypeId'].disable();
      // }
    }
    if (simpleChanges.profile && this.profile) {
      this.profileDetail = this.profile['user'] as User;
      if (this.profileDetail && this.profileDetail.registrationTypeId <= 0 && this.profileDetail.approvalStatusId != 6) {
        this.profileDetail.registrationTypeId = this.lookupSelfRegistration;
      }
      this.registrationTypeChange(this.profileDetail?.registrationTypeId);

      if (!this.profileDetail.isEditable) {
        this.personalForm.disable();
      }
      this.personalForm.patchValue({
        ...this.profileDetail,
        dob: new Date(this.profileDetail.dob),
      });
      this.approvalForm.patchValue({...this.profileDetail});
      this.selectProvince(this.profileDetail.provinceId);
      if (this.profileDetail && this.profileDetail.approvalStatusId != 4) {
        this.approvalForm.controls['taggedUserId'].disable();
        this.approvalForm.controls['otherDetails'].disable();
        this.approvalForm.controls['registrationTypeId'].disable();
      }
    }
  }

  rejectUser() {
    // only admin user can reject 
    if (!this.isPartyUser && this.profile && this.profile.user.approvalStatusId == 4) {
      const data = { userId: this.profile.user.userId, approvalStatusId: 6 };
      this.userService.setUserStatus(data).subscribe((res: any) => {
        this.notification.success(res['message']);
      });
    }
  }

  approveUser() {
// only admin user can approve 
    if (!this.isPartyUser && this.profile != undefined && this.profile.user.approvalStatusId == 4) {
      let form = this.approvalForm.value;
      if (form.registrationTypeId === this.lookupBDURegistration) {
        if (form.taggedUserId == null || form.taggedUserId <= 0) {
          this.notification.error("Please select business development user.");
          return;
        }
        form.otherDetails = "";
      }
      if (form.registrationTypeId === this.lookupOtherRegistration) {
        if (form.otherDetails == null || form.otherDetails === "") {
          this.notification.error("Registration detail cannot be empty.");
          return;
        }
        form.taggedUserId = 0;
      }

      const data = {
        userId: this.profile.user.userId,
        approvalStatusId: 5,
        registrationTypeId: form.registrationTypeId,
        taggedUserId: form.taggedUserId,
        otherDetails: form.otherDetails,
      };
      this.userService.setUserStatus(data).subscribe((res: any) => {
        this.notification.success(res['message']);
      });
    }
  }
  // -- Select Province -- //
  selectProvince(value: any) {
    let province = value;
    this.provinceCities = this.metaData?.city.filter((city: any) => {
      return city.provinceId == province;
    });
  }


  public get f() {
    return this.personalForm.controls;
  }

  // --- On Submit ---- //
  public onSubmit(): void {
    this.isSubmitted = true;
    let form = this.personalForm.value;

    this.personalForm.get('userName')?.clearValidators();
    this.personalForm.get('userName')?.updateValueAndValidity();
    this.personalForm.get('departmentId')?.clearValidators();
    this.personalForm.get('departmentId')?.updateValueAndValidity();
    this.personalForm.get('lstRoles')?.clearValidators();
    this.personalForm.get('lstRoles')?.updateValueAndValidity();

    if (this.personalForm.valid) {
      this.isSubmitted = false;
      const personal: User = {
        userId: form.userId,
        firstName: form.firstName,
        middleName: form.middleName,
        lastName: form.lastName,
        email: form.email,
        userName: form.phoneNumber,
        cnic: form.cnic,
        phoneNumberSecondary: form.officePhone,
        phoneNumber: form.phoneNumber,
        networkId: form.networkId,
        area: form.area,
        subArea: form.subArea,
        provinceId: Number(form.provinceId),
        cityId: Number(form.cityId),
        password: form.password,
        genderId: form.genderId,
        dob: form.dob,
        maritalStatusID: 0,
        doj: new Date().toISOString(),
        isPartyUser: true,
        isActive: true,
        isDeleted: false,
        employeeCode: '',
        businessId: form.businessId,
        referredById: form.referredById,
        departmentId: 0,
        lstRoles: [],
        businessCode: '',

      }

      this.emitPersonalForm.emit(personal);
    } else {
      markFormGroupTouched(this.personalForm);
      return;
    }
  }

  // -- Emit User Detail to update in Profile master Module --//
  submit() {
    this.personalForm.get('password')?.clearValidators();
    this.personalForm.get('password')?.updateValueAndValidity();
    this.personalForm.get('confirmPassword')?.clearValidators();
    this.personalForm.get('confirmPassword')?.updateValueAndValidity();
    this.isSubmitted = true;
    let form = this.personalForm.value;
    if (this.personalForm.valid) {
      this.isSubmitted = false;
      const user: User =
      {
        userId: form.userId,
        firstName: form.firstName,
        middleName: form.middleName,
        lastName: form.lastName,
        email: form.email,
        userName: form.phoneNumber,
        cnic: form.cnic,
        phoneNumberSecondary: form.officePhone,
        phoneNumber: form.phoneNumber,
        networkId: form.networkId,
        area: form.area,
        subArea: form.subArea,
        provinceId: Number(form.provinceId),
        cityId: Number(form.cityId),
        password: form.password,
        genderId: form.genderId,
        dob: form.dob,
        maritalStatusID: 0,
        doj: new Date().toISOString(),
        isPartyUser: true,
        isActive: true,
        isDeleted: false,
        employeeCode: '',
        referredById: form.referredById,
        businessId: form.businessId,
        departmentId: form.departmentId,
        lstRoles: form.lstRoles,
        businessCode: ''

      }

      this.emitPersonalDetail.emit(user);
    } else {
      markFormGroupTouched(this.personalForm);
      return;
    }
  }

  // -- On Submit Create New User -- //
  submitCreateUserForm(): void {
    this.isSubmitted = true;
    let form = this.personalForm.value;
    if (this.isCreate) {
      this.personalForm.get('password')?.clearValidators();
      this.personalForm.get('password')?.updateValueAndValidity();
      this.personalForm.get('confirmPassword')?.clearValidators();
      this.personalForm.get('confirmPassword')?.updateValueAndValidity();
    }
    this.personalForm.get('agree')?.clearValidators();
    this.personalForm.get('agree')?.updateValueAndValidity();

    if (this.personalForm.valid) {
      this.isSubmitted = true;
      const createUser: User =
      {
        userId: form.userId,
        firstName: form.firstName,
        middleName: form.middleName,
        lastName: form.lastName,
        email: form.email,
        userName: form.userName,
        cnic: form.cnic,
        phoneNumberSecondary: form.officePhone,
        phoneNumber: form.phoneNumber,
        networkId: form.networkId,
        area: form.area,
        subArea: form.subArea,
        provinceId: Number(form.provinceId),
        cityId: Number(form.cityId),
        password: form.password,
        genderId: form.genderId,
        dob: form.dob,
        maritalStatusID: 0,
        doj: new Date().toISOString(),
        isPartyUser: false,
        isActive: true,
        isDeleted: false,
        employeeCode: '',
        referredById: form.referredById,
        businessId: form.businessId,
        departmentId: Number(form.departmentId),
        lstRoles: this.rolesSelected,
        businessCode: ''

      }
      if (this.isAdmin) {
        if (form.registrationTypeId === this.lookupBDURegistration && (form.taggedUserId == null || form.taggedUserId <= 0)) {

          this.notification.error("Please select business development user.");
          return;

        }
        if (form.registrationTypeId === this.lookupOtherRegistration && (form.otherDetails == null || form.otherDetails === "")) {
          this.notification.error("Registration detail cannot be empty.");
          return;
        }

        createUser.taggedUserId = form.registrationTypeId !== this.lookupBDURegistration ? 0 : form.taggedUserId;
        createUser.otherDetails = form.registrationTypeId !== this.lookupOtherRegistration ? "" : form.otherDetails;

        createUser.registrationTypeId = form.registrationTypeId;
      }
      else { // user updating its profile after approval...
        if (!this.isCreate) {


          createUser.taggedUserId = this.personalInfo.taggedUserId;
          createUser.registrationTypeId = this.personalInfo.registrationTypeId;
          createUser.otherDetails = this.personalInfo.otherDetails;
        }
      }
      this.emitcreateNewUserForm.emit(createUser);
    } else {
      markFormGroupTouched(this.personalForm);
      return;
    }
  }


  registrationTypeChange(typeValue: any) {
    this.isBDURegistration = false;
    this.isOtherRegistration = false;
    this.personalForm.patchValue({ taggedUserId: null });
    this.personalForm.patchValue({ otherDetails: "" });

    if (typeValue == this.lookupBDURegistration) {

      this.isBDURegistration = true;
      this.isOtherRegistration = false;
    }
    else if (typeValue === this.lookupOtherRegistration) {
      this.isBDURegistration = false;
      this.isOtherRegistration = true;
    }
  }

  // ---- Init Form ----- //
  initForm() {
    this.personalForm = this.fb.group({
      userId: [0],
      businessId: [0],
      firstName: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      middleName: ['', {
        updateOn: 'change'
      }],
      lastName: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      userName: ['', {
        updateOn: 'change', validators: [
          // Validators.required,
          Validators.minLength(5)
        ]
      }],
      cnic: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      dob: ['', {
        updateOn: 'blur', validators: [
          Validators.required,
          DobValidator
        ]
      }],
      genderId: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      networkId: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      phoneNumber: ['', {
        updateOn: 'change', validators: [
          Validators.required,
        ]
      }],
      officePhone: [''],
      email: ['', {
        updateOn: 'change', validators: [
          Validators.maxLength(128),
          Validators.pattern(regex.email)
        ]
      }],
      provinceId: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      cityId: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      area: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      subArea: ['', {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      departmentId: [null, {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      referredById: [90, {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      password: [null, {
        updateOn: 'change', validators: [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(30),
          Validators.pattern(regex.password)
        ]
      }],
      confirmPassword: [null, {
        updateOn: 'change', validators: [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(30)
        ]
      }],
      lstRoles: [null,
        Validators.required
      ],
      agree: [null, Validators.required],
      

    },
      {
        validator: repeatPasswordValidator
      });
    this.approvalForm = this.fb.group({
      taggedUserId: [null, {
        updateOn: 'change', validators: [
          //Validators.required
        ]
      }],
      registrationTypeId: [130, {
        updateOn: 'change', validators: [
          Validators.required
        ]
      }],
      otherDetails: ["", {
        updateOn: 'change', validators: [
          //
        ]
      }]
    },{});


  }

  // -- If lstRoles has error -- //
  public get lstRoles() {
    return this.personalForm.controls['lstRoles'].hasError('required');
  }

  public get not18() {
    return this.personalForm.controls['dob'].hasError('not18');
  }

  // ----- checkbox for I agree ----- //
  changeAgreeCheck(event: { target: { checked: boolean; }; }) {
    if (event.target.checked) {
      this.personalForm.controls.agree.setValue(true);
    } else {
      this.personalForm.controls.agree.setValue(null);
    }
  }


  // -- On Item Select -- //
  onItemSelect(item: any): void {
    this.rolesSelected.push(item['item_id']);
  }

  // -- On all select Multidrop down -- //
  onSelectAll(item: any) {
    this.rolesSelected = item.map((data: any) => {
      return data.item_id;
    })
  }

  // -- On Item Deselct from Multiselect -- //
  onItemDeSelect(item: any): void {
    const index: number = this.rolesSelected.indexOf(item['item_id']);
    if (index !== -1) {
      this.rolesSelected.splice(index, 1);
    }
  }

  // -- On Item Deselct All from Multiselect -- //
  onItemDeSelectAll(item: any): void {
    this.rolesSelected = [];
  }

}
